module.exports = __webpack_public_path__ + "img/Small_jocke.ff4886be.png";